export default (futureDate: ComputedRef<Date>, updateFrequency: 'second' | 'hour') => {
  const timeLeft = reactive({
    seconds: ref(0),
    minutes: ref(0),
    hours: ref(0),
    days: ref(0),
    months: ref(0),
    isInit: ref(false),
    ended: ref(false)
  });

  const intervalValue = {
    second: 1000,
    hour: 3600000
  }[updateFrequency];

  const calculateTimeLeft = () => {
    const timeRemaining = futureDate.value.getTime() - Date.now();

    if (timeRemaining <= 0) {
      timeLeft.seconds = 0;
      timeLeft.minutes = 0;
      timeLeft.hours = 0;
      timeLeft.days = 0;
      timeLeft.months = 0;
      timeLeft.ended = true;
      return;
    }

    timeLeft.seconds = Math.floor((timeRemaining / 1000) % 60);
    timeLeft.minutes = Math.floor((timeRemaining / 1000 / 60) % 60);
    timeLeft.hours = Math.floor((timeRemaining / (1000 * 60 * 60)) % 24);

    timeLeft.days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));

    timeLeft.months = Math.floor(timeLeft.days / 30);
    return timeLeft;
  };

  let interval: NodeJS.Timeout;
  onBeforeMount(() => {
    clearCountdown();
    calculateTimeLeft();
    interval = setInterval(calculateTimeLeft, intervalValue);
    timeLeft.isInit = true;
  });

  const clearCountdown = () => {
    clearInterval(interval);
    timeLeft.isInit = false;
  };

  const restartCountdown = () => {
    clearCountdown();
    timeLeft.ended = false;
    interval = setInterval(calculateTimeLeft, intervalValue);
  };

  watch([() => futureDate], () => {
    const timeRemaining = Date.parse(futureDate.value.toString()) - Date.now();
    if (timeRemaining < 0 && import.meta.client) {
      clearCountdown();
      timeLeft.ended = true;
      return timeLeft;
    }
  });

  watch(
    futureDate,
    () => {
      if (import.meta.client) {
        clearCountdown();
        interval = setInterval(calculateTimeLeft, intervalValue);
      }
    },
    { immediate: true }
  );

  return {
    timeLeft,
    clearCountdown,
    restartCountdown
  };
};
